import React from 'react';

function SidebarForm(props) {
  return null
  // Uncomment following code lines to add Sidebar Form
  // return (
  //   <div className="sidebar-form"></div>
  // )
}

export default SidebarForm;
